import React from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, ListItem, ListItemIcon, ListItemText, Skeleton, Stack, Typography } from '@mui/material'

function SkeletonChip() {
  return <Skeleton variant="rounded" width={100} height={24} />
}

function SkeletonSchedulingMapServicePopover({ showList = false, sx = { width: 440, maxWidth: 480, p: 1 } }) {
  return (
    <Box sx={sx}>
      {/* Header */}
      <Box display="flex" alignItems="center" gap={1} mb={1} flexWrap="nowrap">
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width={220} height={28} />
        <Box ml="auto" display="flex" alignItems="center" gap={0.5}>
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="text" width={80} height={20} />
        </Box>
      </Box>

      {/* Chips and weekly summary */}
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
        <SkeletonChip />
        <SkeletonChip />
        <Stack sx={{ mt: 0.5, width: '100%' }} justifyContent="center" alignItems="center">
          <Skeleton variant="rounded" width="100%" height={36} />
        </Stack>
      </Box>

      {showList && (
        <>
          <Divider />
          <Box mt={1} display="flex" flexDirection="column" gap={1}>
            {[0, 1, 2].map((i, index) => (
              <React.Fragment key={i}>
                <ListItem disableGutters disablePadding sx={{ gap: 8 }}>
                  <ListItemText
                    sx={{ m: 0 }}
                    primary={<Skeleton variant="text" width={120} height={24} />}
                    secondary={<Skeleton variant="text" width={60} height={18} />}
                  />
                  <ListItemIcon>
                    <Skeleton variant="rounded" width={100} height={24} />
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  disableGutters
                  disablePadding
                  sx={{ gap: 8, justifyContent: 'space-between', pb: 0.5 }}
                  divider={index !== 2}
                >
                  <ListItemIcon>
                    <Skeleton variant="rounded" width={110} height={22} />
                  </ListItemIcon>
                  <ListItemIcon>
                    <Skeleton variant="rounded" width={150} height={22} />
                  </ListItemIcon>
                </ListItem>
              </React.Fragment>
            ))}
            <Typography variant="body2" color="text.secondary" sx={{ visibility: 'hidden' }}>
              No work orders for this week
            </Typography>
          </Box>
        </>
      )}
    </Box>
  )
}

SkeletonSchedulingMapServicePopover.propTypes = {
  showList: PropTypes.bool,
  sx: PropTypes.object,
}

export default SkeletonSchedulingMapServicePopover
